import { useSelector } from 'react-redux';
import { NAMESPACE } from './constants';
export const useIsEligibleForVoucher = () => {
    const { isEligibleForVoucher } = useSelector((state) => {
        const platformJourney = state[NAMESPACE];
        return platformJourney;
    });
    return isEligibleForVoucher;
};
//# sourceMappingURL=useIsEligibleForVoucher.js.map